var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"ya-te-footer co-bg-black-1"},[_c('div',{staticClass:"text-center co-text-gray-3 co-py-20"},[_c('small',[_vm._v("© LY Corporation"),_c('br'),_vm._v("© KiRAMEX Corporation")])])])
}]

export { render, staticRenderFns }